import React from "react";
import styles from "./dialogLoader.module.scss";

const DialogLoader: React.FC<{ message?: string }> = ({
  message = "We're processing your request. Please wait...",
}) => {
  return (
    <div className={styles.dialogLoaderWrapper}>
      <div className={styles.pulsingCircle}></div>
      <p className={styles.loaderMessage}>{message}</p>
    </div>
  );
};

export default DialogLoader;
